import { SHIPMENT_TRACKING_LEVELS } from '../types'

interface IFormatTrackingSegmentProps {
  id: string
  description: string
  level: SHIPMENT_TRACKING_LEVELS
  title?: string
}

const formatTrackingSegment = (
  shipperTrackingSegment?: IFormatTrackingSegmentProps
): IFormatTrackingSegmentProps | undefined => {
  if (!shipperTrackingSegment) {
    return undefined
  }

  const { description, level } = shipperTrackingSegment || {}
  return {
    title: `Level ${level}: ${description}`,
    ...shipperTrackingSegment,
  }
}

export default formatTrackingSegment
